import React, { useState, useEffect } from "react";
import { Button } from "rsuite";
import { numberFormatter } from "../../utils";
import { CSVLink, CSVDownload } from "react-csv";
import Details from "./details";
import SupplierChart from "./supplierChart";

const Overview = (props: any) => {
	const data = props.data;
	const {chartTableData, chartData,pieChartData,lineChartData,detailsData, page, detailViewType, legendData,
    exportData, getExportData
  }=props

	return (
		<>
			{page == "overview" && (
				<div className="overview-container contentBox flex flex-col gap-y-[2vh]">
					{props.tableLoading ? (
						<div className="loaderCustom"></div>
					) : (
						<>
							{Object.keys(data).length > 0 &&
							props.l3.length > 0 ? (
								<>
									<div className="max-h-full overflow-y-auto">
										<table className="common-table-ui">
											<thead>
												<tr>
													<th>District</th>
													<th>2025 YTD Sales</th>
													<th>
														Spend % with Preferred
														Supplier
													</th>
													<th>
														Spend % with Sub Optimal
														Margin
													</th>
													<th>Lost Opportunity</th>
												</tr>
											</thead>
											<tbody>
												{Object.keys(data).map(
													(d: any, index: any) => {
														return (
															<tr
																key={d}
																onClick={() => {
																	props.handleDistrictRowClick(
																		d
																	);
																	props.updateSelectedDistrict(
																		d
																	);
																	props.updateSelectedL4(
																		null
																	);
																}}
																className={`cursor-pointer 
																	${props.selectedDistrict === d ? "selected-row" : ""}
																	${
																		props.selectedDistrict !== d && props.selectedDistrict !== null
																			? ""
																			: ""
																	}
																`}
															>
																<td>{d}</td>
																<td>
																	{numberFormatter(
																		data[d]
																			.salesCurrentYear,
																		0,
																		"$"
																	)}
																</td>
																<td>
																	{data[
																		d
																	].spendPrcntPS.toFixed(
																		2
																	)}{" "}
																	%
																</td>
																<td>
																	{data[
																		d
																	].spendPrcntNonOptimal.toFixed(
																		2
																	)}{" "}
																	%
																</td>
																<td>
																	{numberFormatter(
																		data[d]
																			.lostOpportunity,
																		0,
																		"$"
																	)}
																</td>
															</tr>
														);
													}
												)}
											</tbody>
										</table>
									</div>
								</>
							) : (
								<div className="msg-container h-full flex justify-center items-center italic ">
									<span className="text-center text-black text-[2.5vh]">
										Please select L3 category.
									</span>
								</div>
							)}
						</>
					)}
				</div>
			)}
			<div className="overview-container contentBox flex flex-col gap-y-[2vh]">
				{props.l3.length > 0 &&
				props.selectedDistrict ? (
					<SupplierChart
						chartData={chartData}
						pieChartData={pieChartData}
						lineChartData={lineChartData}
						legendData={legendData}
						chartTableData={chartTableData}
						selectedL4={props.selectedL4}
						updateSelectedL4 = {(l:any)=>{
							props.updateSelectedL4(l);
						}}
						selectedDistrict = {props.selectedDistrict}
						page = {page}
						detailViewType = {detailViewType}
						handleTabChange={(tab:any)=>{
							props.handleTabChange(tab);
						}}
						updatePopUp = {(value:any)=>props.updatePopUp(value)}
					/>
				) : (
					<div className="msg-container h-full flex justify-center items-center italic ">
						<span className="text-center text-black text-[2.5vh]">
							{" "}
							Please select the District from{" "}
							{`${
								page == "details"
									? "Overview tab."
									: "LHS table."
							}`}{" "}
						</span>
					</div>
				)}
			</div>
			{page == "details" && (
				<Details
					detailsData={detailsData}
					selectedL4={props.selectedL4}
					detailViewType = {detailViewType}
					exportData = {exportData}
					getExportData = {()=>{getExportData()}}
				/>
			)}
		</>
	);
};
export default Overview;
